<template>
  <v-card elevation="1" class="">
    <v-card-text>
      <h6 class="text-h6 black--text">Adjuntar comprobante</h6>
      <p class="text-body-2">Subí el comprobante que respalda este gasto.</p>
      <p class="caption">Solo admite formato PDF</p>

      <v-row>
        <v-col md="10">
          <v-text-field
            filled
            dense
            label="Comprobante"
            :value="fileName"
            readonly
            :disabled="isViewModal"
            @click="!isViewModal && triggerFileInput()"
            prepend-inner-icon="attach_file"
          ></v-text-field>
        </v-col>

        <v-col md="2">
          <div class="d-flex justify-center align-center mt-4">
            <v-tooltip bottom v-if="hasExistingFile()">
              <template v-slot:activator="{ on }">
                <v-icon
                  color="blue"
                  class="mr-2"
                  v-on="on"
                  @click="openFile"
                >
                  remove_red_eye
                </v-icon>
              </template>
              <span>Ver Adjunto</span>
            </v-tooltip>

            <v-tooltip bottom v-if="hasExistingFile() && !isViewModal && canDelete">
              <template v-slot:activator="{ on }">
                <v-icon
                  color="red"
                  v-on="on"
                  @click="confirmDelete"
                >
                  delete
                </v-icon>
              </template>
              <span>Eliminar Adjunto</span>
            </v-tooltip>
          </div>
        </v-col>

        <input
          ref="hiddenFileInput"
          type="file"
          accept=".pdf"
          style="display: none"
          @change="handleFileChange"
          :disabled="isViewModal"
        />
      </v-row>

      <DialogYesNo 
        :open="dialog_delete_comprobante" 
        :title="'Confirmar eliminación'" 
        :message="'¿Estás seguro de eliminar el adjunto?'" 
        :loading="loading_delete_comprobante"
        @accept="deleteComprobanteConfirm" 
        @cancel="cancelDeleteComprobante" 
      />
    </v-card-text>
  </v-card>
</template>

<script>
import DialogYesNo from "@/components/DialogYesNo.vue";

export default {
  components: { DialogYesNo },
  props: {
    open: Boolean,
    isViewModal: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    service: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      dialog_delete_comprobante: false,
      loading_delete_comprobante: false,
    };
  },
  computed: {
    fileName() {
      return this.item.name_file;
    }
  },
  methods: {
    hasExistingFile() {
      return (this.item.file_path || this.item.path) && !this.item.file_base64 && this.item.name_file;
    },
    triggerFileInput() {
      this.$refs.hiddenFileInput?.click();
    },
    openFile() {
      if (this.item.file_path) {
        window.open(this.item.file_path, "_blank");
      } else {
        this.$toast?.error("Archivo no disponible");
      }
    },
    confirmDelete() {
      this.dialog_delete_comprobante = true;
    },
    cancelDeleteComprobante() {
      this.dialog_delete_comprobante = false;
      this.loading_delete_comprobante = false;
    },
    deleteComprobanteConfirm() {
      if (!this.service || !this.item.id) {
        this.$toast?.error("Servicio no disponible o item sin ID", "Error");
        return;
      }
      
      this.loading_delete_comprobante = true;
      this.service
        .deleteComprobante(this.item.id)
        .then((response) => {
          if (response.status === true) {
            this.$toast?.success(response.msg || "Comprobante eliminado correctamente", "OK");
            
            // Limpiar los campos del archivo
            this.item.name_file = null;
            this.item.file = null;
            this.item.file_base64 = null;
            this.item.file_path = null;
            this.item.path = null;
            
            this.cancelDeleteComprobante();
            
            this.$emit('comprobanteDeleted', this.item);
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast?.error(response.message, "Error");
            } else {
              this.$toast?.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          this.$toast?.error("Error al eliminar el comprobante", "Error");
        })
        .finally(() => {
          this.loading_delete_comprobante = false;
        });
    },
    handleFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        this.item.file_base64 = null;
        this.item.file = null;
        this.item.name_file = null;
        return;
      }

      if (file.type !== "application/pdf") {
        this.$toast?.error("Solo se permiten archivos PDF.");
        this.item.file_base64 = null;
        this.item.file = null;
        this.item.name_file = null;
        return;
      }

      this.item.file_path = null;
      this.item.path = null;
      
      this.item.file = file;
      this.item.name_file = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.item.file_base64 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
